import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PromoCodeUser from "../../../components/SuperAdmin/PromoCode/PromoCodeUser";

export default withRouter(connect()(PromoCodeUser));
